import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/kelly-criterion',
  component: () => import('../../routes/KellyCriterion.svelte'),
  card: {
    id: 'kelly-criterion',
    title: 'Kelly Criterion Calculator',
    description: 'Calculate the optimal fraction of your bankroll to bet using the Kelly Criterion formula. Maximize long-term growth while managing risk.',
    icon: 'analytics',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/kelly-criterion',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Kelly Criterion Calculator – Optimal Bet Sizing Strategy',
    description: 'Free Kelly Criterion calculator. Determine the optimal fraction of your bankroll to bet for long-term exponential growth. Supports full Kelly, half-Kelly, and quarter-Kelly strategies.',
  },
};

export default meta;